type PersonNames = {
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
};

const capitalizeNamePart = (part: string): string => {
  const trimmed = part.trim();
  if (!trimmed) {
    return "";
  }
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
};

export const getPersonFullName = ({
  firstName,
  lastName,
  middleName,
}: PersonNames): string | null => {
  if (!firstName && !middleName && !lastName) {
    return null;
  }

  const nameParts = [firstName, middleName, lastName]
    .filter((name): name is string => Boolean(name?.trim()))
    .map(capitalizeNamePart)
    .filter(Boolean);

  if (nameParts.length === 0) {
    return null;
  }

  return nameParts.join(" ").trim();
};
